
 
 
import React, { useContext, useState, useEffect } from "react"
import { Config } from "../config/Config" 
import { BlockBlobClient } from "@azure/storage-blob";
import axios from 'axios';
const AuthContext = React.createContext()
let config = process.env.REACT_APP_SERVER ===  'dev' ? Config.DEV : process.env.REACT_APP_SERVER ===  'prod' ? Config.PROD : Config.LOCAL;

export function useAuth() {
  return useContext(AuthContext)
}

export function AuthProvider({ children }) {

  
  const [loading, setLoading] = useState(false) 
 
  const [requestSuccess, setLoadingSuccessData] = useState() 
  const [requestError, setRequestError] = useState()
  const [currentUser, setCurrentUser] = useState() 
  const [paymentAccount, setPaymentAccount] = useState({plans:[], customer:{}}) 
  var loggedInUser


  const countryList = [
   
  ];

  useEffect(() => {
    const loggedInUser = localStorage.getItem("appkey.io.user");
    setLoadingSuccessData()
    if (loggedInUser && loggedInUser["access-token"]) {
      try {
        const foundUser = JSON.parse(loggedInUser); 
        setCurrentUser(foundUser)
 
      } catch (error) {
        
      }
     
    }
    
  }, [])


  

  async function apiRequest(method, path, data, showLoading = true, file){ 

      const userCache = localStorage.getItem("appkey.io.user"); 
    
      if (userCache && path !== "account/login") loggedInUser = JSON.parse(userCache); 
      else loggedInUser = null 

      setRequestError(null)
      if(showLoading) setLoading(true) 

      try {
          let requestOptions = {
              method: method || 'POST',
              headers: {
                        "access-token": loggedInUser && loggedInUser["access-token"]  ? loggedInUser["access-token"] : "",
                        "signup-token": loggedInUser && loggedInUser["signup-token"]  ? loggedInUser["signup-token"] : ""
                      } 
          };

          if (method !== "GET" && method !== "DELETE" && data){
              requestOptions.body = JSON.stringify(data)
          }
          
          if(data && data.passkeyToken) requestOptions.headers["access-token"] = data.passkeyToken;

          if (file) {
            const formData = new FormData();  
            formData.append('file', file); 
            requestOptions.body = formData
          }
          else {
            requestOptions.headers['Content-Type'] = 'application/json'     
          }

          let endpoint = `${config.REST_API}/api/${path}`

          console.log("apiRequest endpoint ", endpoint)

          const response = await fetch(endpoint, requestOptions); 
          let result = await response.json();

          console.log("apiRequest result ", result)
          
          if (response.status !== 200){
              setRequestError(result);
              if(result.code === 501 || result.code === 405) logout()
              
              return {error:result}
          } 
          else{
              return result;
          } 


      } catch (error) {
           console.log("apiRequest error ", error)
          setRequestError(error)
          return {error:error}
      }
      finally{
          setLoading(false)
      }
  }


  async function recoverAccount(email) {
    try {  
      return await apiRequest("POST", "account/recover", { email: email }, false)  
       
    } catch (error) { 
      return  {error:error}
    } 
  }
   

  async function confirmRecoverAccount(email, code) {
    try { 
     
      return await apiRequest("POST", "account/recoverComplete", { email: email, code:code }, false)  

    } catch (error) { 
      return  {error:error}
    } 
  }

  async function register(data) {

    try { 
      if(!validateEmail(data.email)) return {error:{message:"Please enter a valid email"}}

      logout()
      return await apiRequest("POST", "account/register", data, false)   

    } catch (error) { 
      return  {error:error}
    } 

  }

  function validateEmail(emailToValidate) {
    return (emailToValidate.indexOf("@") > 0 && emailToValidate.indexOf(".") > 2 && emailToValidate.indexOf(".") < emailToValidate.length - 1)
  }



  async function confirmRegister(data) {
    let response = await apiRequest("POST", "account/registerConfirm", data, false) 
    if (!response.error){ 
      
      localStorage.setItem('appkey.io.user', JSON.stringify(response)); 
      sessionStorage.setItem('appkey.io.user', JSON.stringify(response));

      
    } 
    return response;
  }



  async function registerComplete(authData) {
    try { 

      let response = await apiRequest("POST", "account/registerComplete", authData, false)

      if (!response.error){
        localStorage.setItem('appkey.io.user', JSON.stringify(response)); 
        sessionStorage.setItem('appkey.io.user', JSON.stringify(response));
      } 

      setCurrentUser(response)
      
      return response;

    } catch (error) {
      return  {error:error}
    }
  }
 

  async function login(email, clear = true) {
    try {

      if(!validateEmail(email)) return {error:{message:"Please enter a valid email"}}

      if(clear) localStorage.clear(); 

      return await apiRequest("POST", "account/login", { email: email }, false)

       
    } catch (error) {
      console.log(error)
      return {error:error}
    }
  }


  async function loginComplete(assert) {
    try {

      let response = await apiRequest("POST", "account/loginComplete", assert, false)
      
      if (!response.error) {  
        // store the user in localStorage
        localStorage.setItem('appkey.io.user', JSON.stringify(response)); 
        sessionStorage.setItem('appkey.io.user', JSON.stringify(response));

        setCurrentUser(response) 
      } 

      return response;

    } catch (error) {
      console.error(error)
      return {error:error}
    }
  }



  async function inviteAddPasskey() {
    let response = await apiRequest("POST", "account/requestAddPasskey", {}, false)
    return response
  }

 


  async function addPasskey(email, passkeyToken) { 
    
    return  await apiRequest("POST", "account/addPasskey", { email: email, passkeyToken:passkeyToken}, false)
  }




  async function addPasskeyComplete(authData, passkeyToken) {
    if(passkeyToken) authData.passkeyToken = passkeyToken;
    return await apiRequest("POST", "account/addPasskeyComplete", authData, false)
  }

  async function getUser(){
    let response = await apiRequest("GET", "account/user", null, false)
    if (!response.error){
      localStorage.setItem('appkey.io.user', JSON.stringify(response));  
      setCurrentUser(response)
    } 

    return response;
  }


  

  async function updateProfileAvatar(avatar){
    let response = await apiRequest("POST", "account/updateProfileAvatar", avatar, false)
    if (!response.error){ 
      updateUserCache('avatar', response.avatar)
     
    } 

    return response;
  }



  async function setPhoneNumber(phoneNumber){
    let response = await apiRequest("POST", "account/setPhone", {phoneNumber: phoneNumber}, false)
    if (!response.error){ 
      updateUserCache('phoneNumber', response.phoneNumber) 
    } 

    return response;
  }

  async function verifyPhone(data){
    let response = await apiRequest("POST", "account/verifyPhone", data, false)
    if (!response.error){ 
      updateUserCache('phoneVerified', true) 
    } 

    return response;
  }


  async function updateProfile(profile){
    let response = await apiRequest("POST", "account/updateProfile", profile, false)
    if (!response.error){
      updateUserCache('firstName', profile.firstName)
      updateUserCache('lastName', profile.lastName)
      updateUserCache('company', profile.company)
    } 

    return response;
  }

  async function updateUserCache(key, value) {

    const loggedInUser = localStorage.getItem("appkey.io.user");
    if (loggedInUser) {
      try {

        let foundUser = JSON.parse(loggedInUser); 
        if (key === 'replace') foundUser = value
        else foundUser[key] = value

        //console.log("updateUserCache data ", foundUser)

        sessionStorage.setItem('appkey.io.user', JSON.stringify(foundUser));   

        localStorage.setItem('appkey.io.user', JSON.stringify(foundUser));   

        if(key !== 'replace') {
          setCurrentUser({
            ...currentUser,
            [key]:value 
          })
        }
        else setCurrentUser(foundUser)

        return true;

      } catch (error) {
        console.error("cannot get user catche..error ", error)
        return false;
      } 
    }
    else {
      console.error("cannot get user catche...")
      return false;
    }
  }

  async function refreshAccessToken() {
    let response = await apiRequest("GET", `account/refreshToken`, {}, false);

    if (response && response['access-token']) { 
        const loggedInUser = sessionStorage.getItem("appkey.io.user"); 
        let foundUser = JSON.parse(loggedInUser);
        if(foundUser) {
          foundUser['access-token'] = response['access-token'];
          
          localStorage.setItem('appkey.io.user', JSON.stringify(foundUser)); 
          sessionStorage.setItem('appkey.io.user', JSON.stringify(foundUser));
        }
    }
}


  async function removePasskey(keyId) {
    try {  

      let response = await apiRequest("POST", "account/removePasskey", { keyId : keyId }, false)
      if (!response.error){
        // localStorage.setItem('appkey.io.user', JSON.stringify(response));  
        // setCurrentUser(response)
        updateUserCache('replace', response)
      }

      return response;

    } catch (error) {
      console.error(error)
      return {error:error}
    }
  }
 



  async function updatePasskey(authData) {
    try { 
    
      let response = await apiRequest("POST", "account/updatePasskey", authData, false)
      if (!response.error){
         
        updateUserCache('replace',response)
        
      } 

      return response;

    } catch (error) {
      console.log(error)
      return {error:error}
    }
  }



  async function getPlans(){
    return await apiRequest("GET", "payment/plan", null, false)  
  }


  function isLoggedIn(){
    try {
      const catche = localStorage.getItem("appkey.io.user");
      let loggedInUser = JSON.parse(catche); 
      if (loggedInUser && loggedInUser['access-token'] ){ 
        setCurrentUser(loggedInUser)
        return true
      } 
      else  return false
    } catch (error) {
      return false
    } 
  }

  function logout() {
   
    setCurrentUser();
   
    localStorage.clear();
    return true;
  }
 
  async function addPaymentMethod(params) {
    let result = await apiRequest("POST", "payment", params, false)   
    
    return result
  }

  async function subscribe(params, token) {
    params.token = token
    let result = await apiRequest("POST", "payment/subscribe", params, true)  
    if(!result.error){ 
      let text = `You have successfuly subscribed "${result.plan.name}". Your subscription will renew at ${result.nextBillingDate}.`
      setLoadingSuccessData({title : "Success! Thank you for your subscription with AppKey.", message: text})
      updateUserCache("planId", result.plan.developerPlanId)
    }  
    return result
  }

  async function getSubscriptionsAccount() { 

    let result = await apiRequest("GET", "payment/subscriptions", null, true)

    if (!result.error && result.customer) {
      setPaymentAccount({
        ...paymentAccount, 
        customer: { 
          ...paymentAccount.customer, 
          paymentMethods : result.customer.paymentMethods,
          adresses : result.customer.adresses,
          creditCards : result.customer.creditCards,
        },
        plans:{
          ...paymentAccount.plans,
          plans:result.plans
        }
      });

      if(result.user)  localStorage.setItem('appkey.io.user', JSON.stringify(result.user));
    }

   
    return result;
  }



  async function updateAddress(address) { 
    let acc = await apiRequest("POST", "payment/address", address, true)   
    setPaymentAccount(acc)
    return acc;
  }


  async function updateAutoRenewSubscription(sub, value) { 
    sub.autoRenew = value
    let result = await apiRequest("POST", "payment/updateAutoRenewSubscription", sub, true)
    return result
  }


  async function uploadAvatar(fileName, appId) {

    try {  
      let endpoint = `storage/upload?fileName=${fileName}&noCutting=false`;
      if(appId) endpoint =`storage/upload?fileName=${fileName}&noCutting=false&appId=${appId}`
      let result = await apiRequest("GET", endpoint, {} , true)   
      if(!result.error){
        if(!appId)  updateUserCache('avatar', result) 
        return result
        
      }
    } catch (error) { 
      return  {error:error}
    } 

  }

  function dataURItoBlob(dataURI) {
    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
    var byteString = atob(dataURI.split(',')[1]);
  
    // separate out the mime component
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]
  
    // write the bytes of the string to an ArrayBuffer
    var ab = new ArrayBuffer(byteString.length);
  
    // create a view into the buffer
    var ia = new Uint8Array(ab);
  
    // set the bytes of the buffer to the correct values
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
  
    // write the ArrayBuffer to a blob, and you're done
    var blob = new Blob([ab], {type: mimeString});
    return blob;
  
  }


  async function uploadFileToS3 (file, writeUrl, onProgress) {
      try {
         
        onProgress = typeof onProgress === 'function'  ? onProgress  : function(percentage) {};

        if(!file) {
            onProgress(100);
            return;
        };
        const response = await axios.put(writeUrl, file, {
            // Direct raw binary transmission header configuration
            headers: {
                'Content-Type': file.type || 'application/octet-stream',
            },
            // Native Axios outbound request progress listener
            onUploadProgress: (progressEvent) => {
                if (progressEvent.total) {
                    const percentage = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                    onProgress(percentage);
                }
            },
          });
          
          return response;

      } catch (error) {
          // Enhanced error parsing for Axios networking drops
          console.error("Axios S3 upload failure details:", error.response || error);
          throw error;
      }
  };

  async function uploadFileToBlob(sasUrl, data, contentType) {
    try {
      const blockBlobClient = new BlockBlobClient(sasUrl);
      
      let result = await blockBlobClient.uploadData(data, {
        blobHTTPHeaders: { blobContentType: contentType || 'image/png' }
    });
      console.log("File uploaded successfully! Request:", result);
      return result;
    } catch (error) {
     
      console.error("Error uploading file:", error.message);
      setRequestError(error)
      return {error:error}
    }
  }
  

  async function uploadFile( endpoint, file){  

      try {
          let requestOptions = {
              method: 'PUT',
              headers: {
                        "x-ms-blob-type": "BlockBlob",
                        "Content-Type": file.type,
                        "Content-Length": file.size,
                        "x-ms-version": "2023-11-03",
                        "x-ms-date": (new Date()).toUTCString(),
                      } 
          };

          const formData = new FormData();  
          formData.append('file', file); 
          requestOptions.body = formData  
          
          const response = await fetch(endpoint, requestOptions);  
          console.log("apiRequest response ", response)
          return response;

      } catch (error) {
           console.log("apiRequest error ", error)
          setRequestError(error)
          return {error:error}
      }
       
  }



  async function getBillingHistory () {
    let result = await apiRequest("GET", "payment/billingHistory", null, true)
    return result
  }

  async function getInvoice(invoice) {

    const userCache = localStorage.getItem("appkey.io.user"); 
    
    if (userCache) {
      loggedInUser = JSON.parse(userCache); 
    }  

    setRequestError(null)
    setLoading(true) 

    console.log("getInvoice invoice ", invoice)


    let requestOptions = {
      method: 'GET',
      headers: { 
          "access-token": loggedInUser && loggedInUser["access-token"]  ? loggedInUser["access-token"] : "",
         
      } 
    };
    let endpoint = `${config.REST_API}/api/payment/report?invoiceId=${invoice.invoiceId}` 
         
    const response = await fetch(endpoint, requestOptions); 
    console.log("getInvoice response ", response)

    setLoading(false) 

    if (response.status !== 200){
      setRequestError(response); 
      return {error:response}
    } 
    else return response; 

  }

  
  const socialLogin = async (token, provider) => {
      let result = await apiRequest("POST", `account/socialLogin`, { token: token, provider:provider }, true)  
      return result
  }

  const socialLoginComplete = async (data) => {
    let result = await apiRequest("POST", `account/socialLoginComplete`, data, true)  
    if (!result.error){
      localStorage.setItem('appkey.io.user', JSON.stringify(result)); 
      sessionStorage.setItem('appkey.io.user', JSON.stringify(result));
    } 

    setCurrentUser(result)
    return result
  }

  
  const socialSignup = async (token, email, provider, firstName, lastName) => {
      let result = await apiRequest("POST", `account/socialSignup`,  { token: token, email:email, provider:provider, firstName:firstName, lastName:lastName }, true)  
      return result
  }

  const socialSignupComplete = async (data) => {
    let result = await apiRequest("POST", `account/socialSignupComplete`, data, true)  

    if (!result.error){
      localStorage.setItem('appkey.io.user', JSON.stringify(result)); 
      sessionStorage.setItem('appkey.io.user', JSON.stringify(result));
      setCurrentUser(result)
    }
    else setCurrentUser({})

    

    
    return result
  }



  const verify = async () => {
      let result = await apiRequest("POST", `account/verify`, {}, true)  
      return result
  }

  const verifyComplete = async (data) => {
    let result = await apiRequest("POST", `account/verifyComplete`, data, true)  

    if (result && !result.error) { 
      await updateUserCache('replace', result) 
    }  
    return result
  }

  const getAssociatedDomains = async() => {

    let requestOptions = {
      method:  'GET', 
    };

    console.log("getAssociatedDomains requestOptions ", requestOptions)

    let endpoint = `${config.REST_API}/apple-app-site-association`
    const response = await fetch(endpoint, requestOptions);  
    let result = await response.json();

    console.log("getAssociatedDomains result ", result)
    return result
  }

  

  const value = {
    config,
    countryList,
    currentUser, 
    paymentAccount,
    requestSuccess,
    requestError,
    loading,
    setLoading,
    isLoggedIn,
    verify,
    verifyComplete,
    setLoadingSuccessData,
    setRequestError,
    login,  
    loginComplete,
    register,
    confirmRegister,
    registerComplete,
    socialLogin,
    socialLoginComplete,
    socialSignup,
    socialSignupComplete,
    logout,
    recoverAccount,
    confirmRecoverAccount,
    inviteAddPasskey, 
    addPasskey,
    addPasskeyComplete,
    updatePasskey,
    removePasskey,
    getUser,
    updateProfile,
    setPhoneNumber,
    verifyPhone,
    updateProfileAvatar,
    getPlans,
    getSubscriptionsAccount,
    updateAddress,
    uploadAvatar,
    uploadFile,
    uploadFileToBlob,
    uploadFileToS3,
    subscribe,
    addPaymentMethod,
    updateAutoRenewSubscription,
    getBillingHistory,
    getInvoice,
    getAssociatedDomains,
    refreshAccessToken
  }

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  )
}
